import { render, staticRenderFns } from "./GameInfo.vue?vue&type=template&id=74628d1f&scoped=true&"
import script from "./GameInfo.vue?vue&type=script&lang=ts&"
export * from "./GameInfo.vue?vue&type=script&lang=ts&"
import style0 from "./GameInfo.vue?vue&type=style&index=0&id=74628d1f&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74628d1f",
  null
  
)

export default component.exports